export default __webpack_public_path__ + "static/media/1.72813d9d.png";